'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { Configure, InstantSearch } from 'react-instantsearch';
import { ModalContent } from '@src/components/Modal/ModalContent';
import { SearchModalContent } from '@src/components/SearchModal/SearchModalContent';
import { configPublic } from '@src/config.public';
import { useHasMounted } from '@src/hooks/useHasMounted';
import { useLocale } from '@src/i18n/LocaleProvider';
import { getQuerySearchClient } from '@src/utils/searchClient.util';
interface SearchModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const AUTO_SUGGESTION_HITS_PER_PAGE = 5;
export const SearchModal = t0 => {
  const $ = _c(12);
  const {
    isOpen,
    onClose
  } = t0;
  const hasMounted = useHasMounted();
  const {
    t
  } = useLocale("search");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQuerySearchClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const searchClient = t1;
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isOpen && hasMounted;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      preserveSharedStateOnUnmount: true
    };
    t5 = <Configure hitsPerPage={AUTO_SUGGESTION_HITS_PER_PAGE} />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onClose) {
    t6 = <InstantSearch indexName={configPublic.search.suggestionsIndex} searchClient={searchClient} future={t4}>{t5}<SearchModalContent onClose={onClose} /></InstantSearch>;
    $[5] = onClose;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== onClose || $[8] !== t2 || $[9] !== t3 || $[10] !== t6) {
    t7 = <ModalContent size="medium" onClose={onClose} title={t2} isFullScreenMobile={true} dialogClassName="z-1000" isOpen={t3}>{t6}</ModalContent>;
    $[7] = onClose;
    $[8] = t2;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};